var smartPlayerPreRollEventConstants = Object.freeze({
   PRE_ROLL_STARTED: 'preRollStarted',
   PRE_ROLL_FINISHED: 'preRollFinished',
   PRE_ROLL_FINISHED_ACTIONS: {
      REMOVE_NOW: 'removeNow'
   }
});

export default smartPlayerPreRollEventConstants;
